export const API_MAP = {
  sso: process.env.SSO_API,
  smsinbox: process.env.SMSINBOX_API,
  push: process.env.PUSH_API,
  permission: process.env.PERMISSION_API,
  subscription: process.env.SUBSCRIPTION_API,
  webhook: process.env.WEBHOOK_API,
  linktrack: process.env.LINKTRACK_API,
  voucher: process.env.VOUCHER_API,
  brugerindsamling: process.env.BRUGERINDSAMLING_API,
  smsEvents: process.env.SMS_EVENTS_API,
};

export type ApiApp = keyof typeof API_MAP;

export const FRONTEND_MAP: Record<string, string | undefined> = {
  PORTAL: process.env.NEXT_PUBLIC_PORTAL_FRONTEND,
  SMSINBOX: process.env.NEXT_PUBLIC_SMSINBOX_FRONTEND,
  PUSH: process.env.NEXT_PUBLIC_PUSH_FRONTEND,
  PERMISSION: process.env.NEXT_PUBLIC_PERMISSION_FRONTEND,
  SUBSCRIPTION: process.env.NEXT_PUBLIC_SUBSCRIPTION_FRONTEND,
  WEBHOOK: process.env.NEXT_PUBLIC_WEBHOOK_FRONTEND,
  LINKTRACK: process.env.NEXT_PUBLIC_LINKTRACK_FRONTEND,
  VOUCHER: process.env.NEXT_PUBLIC_VOUCHER_FRONTEND,
  SMSEVENTS: process.env.NEXT_PUBLIC_SMS_EVENTS_FRONTEND,
};

export type ApiResult<T> =
  | {
      code: 200 | 201 | 204;
      body: T;
    }
  | {
      code: number;
      error?: string;
      body?: unknown;
    };
